"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    isLowerValueHospitalOrExtras: function() {
        return isLowerValueHospitalOrExtras;
    },
    isLowerValuePackageOrCombined: function() {
        return isLowerValuePackageOrCombined;
    },
    isPackageOrCombined: function() {
        return isPackageOrCombined;
    }
});
var _fp = require("lodash/fp");
var _constants = require("@ahmdigital/constants");
var _getproducttypefromproductid = /*#__PURE__*/ _interop_require_default(require("../../../utils/get-product-type-from-product-id"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ELIGIBLE_PRODUCTS_PACKAGE_OR_COMBINED = [
    _constants.PRODUCT.STARTER_BASIC_EXCESS_500_BLACK_50_EXTRAS,
    _constants.PRODUCT.STARTER_BASIC_EXCESS_750_BLACK_50_EXTRAS,
    _constants.PRODUCT.STARTER_BASIC_EXCESS_500_BLACK_50_SAVER_EXTRAS,
    _constants.PRODUCT.STARTER_BASIC_EXCESS_750_BLACK_50_SAVER_EXTRAS,
    _constants.PRODUCT.STARTER_BASIC_EXCESS_500_CHOOSABLE_50_TEETH,
    _constants.PRODUCT.STARTER_BASIC_EXCESS_750_CHOOSABLE_50_TEETH,
    _constants.PRODUCT.STARTER_FLEXI_BASIC_EXCESS_500,
    _constants.PRODUCT.STARTER_FLEXI_BASIC_EXCESS_750,
    _constants.PRODUCT.STARTER_PACKAGE_BASIC_EXCESS_500,
    _constants.PRODUCT.STARTER_PACKAGE_BASIC_EXCESS_750
];
var ELIGIBLE_PRODUCTS_HOSPITAL_OR_EXTRAS = [
    _constants.PRODUCT.STARTER_BASIC_EXCESS_500,
    _constants.PRODUCT.STARTER_BASIC_EXCESS_750,
    _constants.PRODUCT.BLACK_50_EXTRAS,
    _constants.PRODUCT.BLACK_50_SAVER_EXTRAS
];
var isLowerValuePackageOrCombined = function(productId) {
    return (0, _fp.includes)(productId, ELIGIBLE_PRODUCTS_PACKAGE_OR_COMBINED);
};
var isLowerValueHospitalOrExtras = function(productId) {
    return (0, _fp.includes)(productId, ELIGIBLE_PRODUCTS_HOSPITAL_OR_EXTRAS);
};
var isPackageOrCombined = (0, _fp.memoize)(function(productId) {
    return (0, _fp.includes)((0, _getproducttypefromproductid.default)(productId), [
        _constants.PRODUCT_TYPE.COMBINED,
        _constants.PRODUCT_TYPE.PACKAGE
    ]);
});
